<script>

    export let elementData;

    // console.log('ElementTable elementData', elementData);
    const tableResult = elementData.report.tableResult;
    // console.log('ElementTable tableResult', tableResult);

</script>

<div class="element table">
    <table>
        <thead>
            <tr>
                {#each tableResult.columns as column}
                    <th>{column.name}</th>
                {/each}
            </tr>
        </thead>
        <tbody>
            {#each tableResult.values as value}
                <tr>
                    {#each value as cellContent}
                        <td>{cellContent == null ? '' : cellContent}</td>
                    {/each}
                </tr>
            {/each}
        </tbody>
    </table>
</div>

<style>
    .table {
        overflow-x: scroll;
    }
</style>